import React from 'react';
import Button from "@mui/material/Button";
import './FeedBackButton.scss';

export default function FeedbackButton() {
  return (
    <div role="region" aria-label="Feedback Button" className="feedback-button-wrapper">
      <a href="https://tdx.cornell.edu/TDClient/148/Portal/Requests/TicketRequests/NewForm?ID=7RG1MxJKQhM_&RequestorType=Service"
        target="_blank" rel="noopener noreferrer">
        <Button variant="contained" className="button-primary feedback-button" aria-label='Feedback'>
          Feedback
        </Button>
      </a>
    </div>
  );
}